import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { DashboardEditable as AVPDashboardEditable } from '@atlassian/jsm-enterprise-reports-common/src/ui/new-avp-experience/dashboard-editable/index.tsx';
import { usePathParam, Redirect } from '@atlassian/react-resource-router';
import type { AssetsReportsV2Props } from '../../common/types.tsx';
import { getHostingProduct } from '../../common/utils.tsx';
import { PreferenceBanner } from '../../common/ui/preference-banner/index.tsx';

export const DashboardEditable = ({ workspaceId }: AssetsReportsV2Props) => {
	const [slug] = usePathParam('templateId');
	if (!slug) {
		return <Redirect to="/jira/servicedesk/assets/reports" />;
	}
	return (
		<>
			<PreferenceBanner />
			<Box xcss={dashboardEditableWrapper}>
				<AVPDashboardEditable
					hostingProduct={getHostingProduct()}
					slug={slug}
					workspaceId={workspaceId}
					allowGlobalFilters
				/>
			</Box>
		</>
	);
};

const dashboardEditableWrapper = xcss({
	marginLeft: 'space.400',
	marginRight: 'space.400',
});
